import { motion } from 'framer-motion'

const sharedLetterClass =
  'inline-block transform-gpu perspective-[500px] rotate-x-[8deg] drop-shadow-[2px_2px_1px_rgba(0,0,0,0.3)]'

const line1 = [
  { letter: '', className: 'mr-[5rem]' },
  { letter: 'S', className: 'scale-x-250 tracking-[2.1rem]' },
  { letter: 'E', className: 'scale-x-200 tracking-[1.1rem]' },
  { letter: 'L', className: 'scale-x-150 tracking-[0.35rem]' },
  { letter: 'F', className: 'scale-x-100 tracking-[-0.2rem]' },
  { letter: 'I', className: 'scale-x-90 tracking-[-1rem]' },
  { letter: 'E', className: 'scale-x-50 tracking-normal' },
]

const line2 = [
  { letter: '', className: '-mr-[2rem]' },
  { letter: 'B', className: 'scale-x-50 tracking-[-0.42em]' },
  { letter: 'O', className: 'scale-x-90 tracking-[0rem]' },
  { letter: 'T', className: 'scale-x-150 tracking-[0.25rem]' },
  {
    letter: '.',
    className: 'scale-x-100 text-red-500 tracking-[0.75rem] skew-x-[5deg]',
  },
  { letter: 'R', className: 'scale-x-150 tracking-[1.3rem]' },
  { letter: 'U', className: 'scale-x-200 tracking-[-0.1em]' },
]

function Logo({ className }) {
  return (
    <div className="relative w-full flex items-center justify-center overflow-hidden">
      <h1
        className={`text-7xl font-extrabold text-red-300 font-montserrat leading-[3.8rem] flex flex-col relative z-10 ${className}`}
      >
        <div className="slogan text-center">
          &nbsp;&nbsp;&nbsp;&nbsp; ПРОРЫВНОЙ ИНСТРУМЕНТ МАРКЕТИНГА
        </div>

        <motion.div
          className="flex justify-center space-x-1"
          initial={{ x: '-100vw', skewX: 50 }}
          animate={{ x: 0, skewX: 0 }}
          transition={{ type: 'spring', stiffness: 80, damping: 12 }}
        >
          {line1.map(({ letter, className }, index) => (
            <span key={index} className={`${sharedLetterClass} ${className}`}>
              {letter}
            </span>
          ))}
        </motion.div>

        <motion.div
          className="flex justify-center space-x-2"
          initial={{ x: '100vw', skewX: -50 }}
          animate={{ x: 0, skewX: 0 }}
          transition={{
            type: 'spring',
            stiffness: 80,
            damping: 12,
            delay: 0.5,
          }}
        >
          {line2.map(({ letter, className }, index) => (
            <span key={index} className={`${sharedLetterClass} ${className}`}>
              {letter}
            </span>
          ))}
        </motion.div>

        <div className="slogan text-center">ВАШИ ГОСТИ ПИШУТ НАМ ПЕРВЫМИ</div>
      </h1>
    </div>
  )
}

export default Logo
